import {createApp} from 'vue'
import App from './App.vue'
import router from './router'

// Custom styles
import '@/assets/css/style.css'
import '@/assets/css/auth-split.css'

/**
 * Importing Plugins
 */
// Vuetify
import Vuetify from '@/plugins/vuetify'
import hasValidationRules from "@/mixins/hasValidationRules";

import Pinia from "@/plugins/pinia";
import snackBar from "@/components/globals/snackBar.vue";
import {mapTiles, initMapConfig} from "@/composables/mapConfig";


// Register global methods

const app = createApp(App)
    .use(Pinia)
    .use(router)
    .use(Vuetify)
    .mixin(hasValidationRules)
    .component('snackBar', snackBar);

// Server-driven map tile/geocoding endpoints, available to every template as
// $mapTiles. Seeded from bootstrap/last-known; refreshed from the server once.
app.config.globalProperties.$mapTiles = mapTiles;
initMapConfig();

app.mount('#app');

// Register fleet service worker for offline BackgroundSync (DVIR + fuel)
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/fleet-sw.js').catch(() => {});
  });
  // Show a snack when a queued request is replayed after reconnect
  navigator.serviceWorker.addEventListener('message', event => {
    if (event.data?.type === 'SYNC_SUCCESS') {
      const label = event.data.entry?.type === 'fuel' ? 'Fuel entry' : 'Inspection';
      console.info(`[SW] ${label} synced after reconnect.`);
    }
  });
}
